// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__ImMO-","validationTips":"StatementDescriptor_validationTips__24JNS"};